import RestaurantStoreDevMenu from './devMenu';

export default RestaurantStoreDevMenu;
